<template>
  <div class="temBox" :style="{height: temBoxHeight}">
    <div v-if="this.flag">
      <ul class="tab-header1">
        <li
          v-for="(tab, index) in optionList"
          :key="index"
          :class="{ active: currentTab === index }"
          @click="selectTab(index, tab.type)"
        >{{ tab.data }}</li>
      </ul>
      <!-- 供货、采购 -->
      <div class="gongcai1">
        <div class="gongcaiBox12">
          <div class="gongtitle11">
            <el-icon style="color: #00A54F;">
              <MessageBox />
            </el-icon>
            <span>供 货 方</span>
          </div>
          <div class="gengduo12" @click="goToWhere(0)">更多信息 >></div>
        </div>

        <div class="tabContent12">
          <div class="tabContentBox12" v-for="(item, index) in dataList" :key="index">
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <span class="designation12">{{ item.product }}</span>
              <!-- <span style="font-size: 15px;margin-right: 10px;margin-left: 10px;">综合服务</span> -->
              <!-- 评分 -->
              <el-rate v-model="item.level" disabled text-color="#FF3B30" />
            </div>
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <span class="gongsi12">{{ item.name }}</span>
              <img class="imgr" src="../image/shilishangjia.png" alt />
            </div>
            <div class="timeBox">
              <span>
                发布日期
                <span>{{ item.publish_start_time }}</span>
              </span>
              <span style="margin-left: 10px;">
                截止日期
                <span>{{ item.publish_end_time }}</span>
              </span>
            </div>
          </div>
        </div>

        <div class="gongcaiBox12">
          <div class="gongtitle11" style="  background: #FFD7D9;">
            <el-icon style="color: #FF7A00;">
              <Handbag />
            </el-icon>
            <span>采 购 方</span>
          </div>
          <div class="gengduo12" @click="goToWhere(0)">更多信息 >></div>
        </div>

        <div class="tabContent12">
          <div class="tabContentBox12" v-for="(item, index) in dataList2" :key="index">
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <span class="designation12">{{ item.product }}</span>
              <!-- <span style="font-size: 15px;margin-right: 10px;margin-left: 10px;">综合服务</span> -->
              <!-- 评分 -->
              <el-rate v-model="item.level" disabled text-color="#FF3B30" />
            </div>
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <span class="gongsi12">{{ item.name }}</span>
              <img class="imgr" src=https://deiyustatic.oss-cn-beijing.aliyuncs.com/home/shilishangjia.png alt="">
            </div>
            <div class="timeBox">
              <span>
                发布日期
                <span>{{ item.publish_start_time }}</span>
              </span>
              <span style="margin-left: 10px;">
                截止日期
                <span>{{ item.publish_end_time }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <ul class="tab-header">
        <li
          v-for="(tab, index) in optionList"
          :key="index"
          :class="{ active: currentTab === index }"
          @click="selectTab(index, tab.type)"
        >{{ tab.data }}</li>
      </ul>
      <!-- 供货、采购 -->
      <div class="gongcai">
        <div class="gongcaiBox1">
          <div class="gongtitle">
            <el-icon style="margin-left: 10px;margin-right: 5px;color: #00A54F;font-size: 1.1vw;">
              <MessageBox />
            </el-icon>
            <span>供 货 方</span>
          </div>
          <div class="gengduo" @click="goToWhere(0)">更多信息 >></div>
        </div>
        <div class="gongcaiBox1">
          <div class="gongtitle1">
            <el-icon style="margin-left: 10px;margin-right: 5px;color: #FF7A00;font-size: 1.1vw;">
              <Handbag />
            </el-icon>
            <span>采 购 方</span>
          </div>
          <div class="gengduo" @click="goToWhere(1)">更多信息 >></div>
        </div>
      </div>
      <!-- 选项卡内容 -->
      <div style="display: flex;justify-content: space-between;">
        <div class="tabContent">
          <div class="tabContentBox" v-for="(item, index) in dataList" :key="index">
            <div class="shang">
              <div style="display: flex;align-items: center;">
                <span class="designation">{{ item.product }}</span>
                <!-- 要改------------------------------------- -->
                <img src=https://deiyustatic.oss-cn-beijing.aliyuncs.com/home/shilishangjia.png alt="">
                <span
                  style="font-size: 0.8vw;margin-right: 10px;margin-left: 10px;"
                >综合服务</span>
                <!-- 评分 -->
                <el-rate v-model="item.level" disabled text-color="#FF3B30" />
              </div>
              <div class="timeBox">
                <span>
                  发布日期
                  <span>{{ item.limit_time }}</span>
                </span>
                <span style="margin-left: 10px;">
                  截止日期
                  <span>{{ item.limit_time }}</span>
                </span>
              </div>
            </div>

            <div class="xunjia">
              <div class="xun">询 价</div>
              <div class="baoyou" v-if="item.delivery == 1">包送</div>
              <div class="xunjiaBox">
                <span class="gongsi">{{ item.name }}</span>
                <span>晚发必赔·极速退货</span>
                <div>
                  <span>{{ item.address }} |</span>
                  <span>卖家承担运费 |</span>
                  <span>承诺48小时发货</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 采购 -->
        <div class="tabContent">
          <div class="tabContentBox" v-for="(item, index) in dataList2" :key="index">
            <div class="shang">
              <div style="display: flex;align-items: center;">
                <span class="designation">{{ item.product }}</span>
                <img src=https://deiyustatic.oss-cn-beijing.aliyuncs.com/home/shilishangjia.png alt="">
                <span
                  style="font-size: 0.8vw;margin-right: 10px;margin-left: 10px;"
                >综合服务</span>
                <el-rate v-model="item.level" disabled text-color="#FF3B30" />
              </div>
              <div class="timeBox">
                <span>
                  发布日期
                  <span>{{ item.limit_time }}</span>
                </span>
                <span style="margin-left: 10px;">
                  截止日期
                  <span>{{ item.limit_time }}</span>
                </span>
              </div>
            </div>
            <div class="xunjia">
              <div class="xun">询 价</div>
              <div class="baoyou" v-if="item.delivery == 1">包送</div>
              <div class="xunjiaBox">
                <span class="gongsi">{{ item.name }}</span>
                <span>晚发必赔·极速退货</span>
                <div>
                  <span>{{ item.address }} |</span>
                  <span>卖家承担运费 |</span>
                  <span>承诺48小时发货</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// import {dataType} from "element-plus/es/components/table-v2/src/common";
import { ajax } from "../../../api/index";

export default {
  data() {
    return {
      currentTab: 0,
      optionList: [
        {
          data: "全 部",
          id: 1,
          type: 1
        },
        {
          data: "鲜 藕",
          id: 2,
          type: 10
        },
        {
          data: "鲜 莲",
          id: 3,
          type: 20
        },
        {
          data: "加 工 品",
          id: 4,
          type: 30
        },
        {
          data: "饮 品",
          id: 5,
          type: 40
        }
      ],
      // 子组件接受参数
      dataList: {},
      dataList2: {},
      width: window.innerWidth,
      flag: false
    };
  },
  computed: {
    temBoxHeight() {
      // 判断对象是否为空
      const isDataListEmpty = Object.keys(this.dataList).length === 0;
      const isDataList2Empty = Object.keys(this.dataList2).length === 0;

      // 如果两个对象都为空，则返回 200px；否则返回 auto
      return isDataListEmpty && isDataList2Empty ? "200px" : "auto";
    }
  },
  methods: {
    selectTab(index, type) {
      this.currentTab = index; // 设置当前激活的选项卡
      this.type = type; // 设置当前激活的选项卡
      this.changeAjax(type);
      this.changeAjax2(type);
    },
    goToWhere(index) {
      this.$router.push({
        path: "more",
        query: {
          ids: index
        }
      });
    },
    async changeAjax(data) {
      if (data === 1) {
        let res = await ajax.reSeller({
          dataType: 0
        });
        console.log(res, "供货");
        this.dataList = res.results.splice(0, 5);
      } else {
        let res = await ajax.reSeller({
          type: data,
          dataType: 0
        });
        this.dataList = res.results.splice(0, 5);
      }
    },

    async changeAjax2(data) {
      if (data === 1) {
        let res = await ajax.reSeller({
          dataType: 1
        });
        console.log(res, "采购");
        this.dataList2 = res.results.splice(0, 5);
      } else {
        let res = await ajax.reSeller({
          type: data,
          dataType: 1
        });
        this.dataList2 = res.results.splice(0, 5);
      }
    },
    // 获取宽度
    updateWidth() {
      this.width = window.innerWidth;
      if (this.width < 599) {
        this.flag = true;
      } else {
        this.flag = false;
      }
    }
  },
  mounted() {
    this.changeAjax(1);
    this.changeAjax2(1);
    // 获取宽度
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  }
};
</script>

<style lang="less" scoped>
::v-deep .el-rate .el-rate__icon.is-active {
  color: #ff3b30;
}

::v-deep .el-icon .el-rate__icon {
  margin: 0;
}

.tabContentBox {
  width: 100%;
  border: 1px solid #ddd;
  padding: 0 10px 8px 10px;
  box-sizing: border-box;
  margin-bottom: 0.5vh;
  transition: border-color 0.5s ease-in-out;

  &:hover {
    border: 1px solid #00a54f;
    cursor: pointer;
  }
}

.xunjia {
  display: flex;
  align-items: center;
}

.xun {
  width: 3vw;
  height: 3vh;
  background: #dde8c0;
  border-radius: 5px;
  text-align: center;
  font-size: 0.7vw;
  line-height: 3vh;
}

.baoyou {
  background: rgba(117, 241, 176, 0.5);
  color: #00a54f;
  border: 1px solid #75f1b0;
  width: 2.5vw;
  height: 3vh;
  line-height: 3vh;
  font-size: 0.7vw;
  text-align: center;
  box-sizing: border-box;
  margin-left: 1vw;
  border-radius: 4px;
}

.xunjiaBox {
  font-size: 0.8vw;
  color: #bbb;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.gongsi {
  font-size: 0.8vw;
  font-weight: 800;
  margin-left: 20px;
  color: #000;
}

.timeBox {
  color: #bbb;
  font-size: 0.8vw;
}

.shang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5vh;

  img {
    width: 5.5vw;
  }
}

.designation {
  font-size: 1.1vw;
  letter-spacing: 0.2vw;
  font-weight: 800;
}

.formList {
  width: 90%;
  margin: 0 auto;
}

.tabContent {
  width: 48%;
}

.gongcai {
  width: 100%;
  height: 50px;
  margin: 3px 0 4px 0;
  display: flex;
  justify-content: space-between;
}

.gongcaiBox1 {
  width: 48%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.gongtitle {
  width: 115px;
  height: 50px;
  background: #dde8c0;
  display: flex;
  align-items: center;
  // justify-content: space-around;
  border-radius: 10px;
  font-size: 17px;

  span {
    margin: 5px;
    font-weight: 900;
    font-size: 0.9vw;
  }
}

.gongtitle1 {
  width: 115px;
  height: 50px;
  background: #ffd7d9;
  display: flex;
  align-items: center;
  // justify-content: space-around;
  border-radius: 10px;
  font-size: 1.5vw;

  span {
    margin: 5px;
    font-weight: 900;
    font-size: 0.9vw;
  }
}

.gengduo {
  font-weight: 900;
  cursor: pointer;
  font-size: 1vw;
}

.tab-header {
  display: flex;
  justify-content: space-between;
  width: 26%;
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size: 1.1vw;
}

.tab-header li {
  width: 80px;
  height: 40px;
  border: 1px solid #ccc;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  border-radius: 10px;
  font-weight: 500;
}

.tab-header li.active {
  background: #00a54f;
  color: #fff;
  font-weight: 500;
  border: 1px solid #fff;
}

.temBox {
  width: 100%;
  min-height: 740px;
  padding: 20px 40px;
  box-sizing: border-box;
}

//
//
//  ------------------------------------------------------------ 缩小的样式----------------------------------------------------------------------------------------------------
//
//
//

.tab-header1 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size: 12px;
}

.tab-header1 li {
  width: 80px;
  height: 40px;
  border: 1px solid #ccc;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  border-radius: 10px;
  font-weight: 500;
}

.tab-header1 li.active {
  background: #00a54f;
  color: #fff;
  font-weight: 500;
  border: 1px solid #fff;
}

.gongcai1 {
  width: 100%;
  height: 40px;
  margin: 3px 0 4px 0;
}

.gongcaiBox12 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.gongtitle11 {
  width: 100px;
  height: 40px;
  background: #dde8c0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 10px;
  font-size: 15px;

  span {
    font-weight: 900;
    font-size: 15px;
  }
}

.gengduo12 {
  font-weight: 900;
  cursor: pointer;
  font-size: 15px;
}

.tabContent12 {
  width: 100%;
}

.tabContentBox12 {
  width: 100%;
  height: 115px;
  border: 1px solid #ddd;
  padding: 10px 0 0 10px;
  box-sizing: border-box;
  margin-top: 10px;
  transition: border-color 0.5s ease-in-out;

  &:hover {
    border: 1px solid #00a54f;
    cursor: pointer;
  }
}

.shang12 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;

  img {
    width: 100px;
  }
}

.designation12 {
  font-size: 20px;
  letter-spacing: 3px;
  font-weight: 600;
}

.xun12 {
  width: 50px;
  height: 30px;
  background: #dde8c0;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  line-height: 30px;
}

.baoyou12 {
  background: rgba(117, 241, 176, 0.5);
  color: #00a54f;
  border: 1px solid #75f1b0;
  width: 50px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 4px;
  margin-right: 15px;
}

.gongsi12 {
  font-size: 12.5px;
  font-weight: 800;
  color: #000;
  white-space: nowrap;
}

.imgr {
  width: 115px;
}

.timeBox {
  color: #bbb;
  font-size: 10px;
}

@media (max-width: 599px) {
  .gongsi {
    font-size: 0.8vw;
    font-weight: 800;
    margin-left: 20px;
    color: #000;
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .temBox {
    width: 100%;
    min-height: 1400px;
    padding: 20px 40px;
    box-sizing: border-box;
  }

  .gongtitle1 {
    width: 115px;
    height: 50px;
    background: #ffd7d9;
    display: flex;
    align-items: center;
    // justify-content: space-around;
    border-radius: 10px;
    font-size: 1.5vw;

    span {
      margin: 5px;
      font-weight: 900;
      font-size: 0.9vw;
    }
  }
}
</style>